import isEmpty from "lodash/isEmpty"

// JSON LD to add header of DOM
export const addJSONLDToHead = (script, id) => {
  const el = document.createElement(`script`)
  el.type = `application/ld+json`
  el.id = id
  el.text = JSON.stringify(script)
  document.head.appendChild(el)
}

// Removes an element from the document
export const removeElement = (elementId) => {
  const element = document.getElementById(elementId)
  return isEmpty(element) ? null : element.parentNode.removeChild(element)
}

export const getSchemaFormattedData = (data) =>
  data.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))

export const getJSONLDFormattedData = (data, isHttps) => ({
  "@context": isHttps ? `https://schema.org` : `http://schema.org`,
  "@type": `FAQPage`,
  mainEntity: data,
})

export const addRemoveJSONLD = (id, path, data, isHttps = false) => {
  if (
    window.location.pathname === path &&
    document.getElementById(id) === null
  ) {
    const script = getJSONLDFormattedData(getSchemaFormattedData(data), isHttps)
    addJSONLDToHead(script, id)
  } else {
    removeElement(id)
  }
}

export const addSchemaDirectly = (id, path, data) => {
  if (
    window.location.pathname === path &&
    document.getElementById(id) === null
  ) {
    addJSONLDToHead(data, id)
  } else {
    removeElement(id)
  }
}
